import { styled, ListItem, ListItemText, Grid } from "@mui/material";
import BarekamText from "../../../components/text";

export const GridItem = styled(Grid)`
  width: -webkit-fill-available !important; 
  padding-left: 0 !important;

  @media screen and (max-width: 1024px) {
   max-width: 100% !important; 
  }
`;

export const BarekamTextProhibited = styled(BarekamText)`
  display: flex !important;
  align-items: center !important;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 1.5rem;
  background-color: #da1944;
  padding: 10px;
  border-radius: 4px;
  gap: 4px;
`;

export const BarekamTextRestricted = styled(BarekamText)`
  display: flex !important;
  align-items: center !important;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 1.5rem;
  background-color: #dd6b20;
  padding: 10px;
  border-radius: 4px;
  gap: 4px;
`;

export const ListItemWrapper = styled(ListItem)`
  padding-left: 0;
  min-height: 52px;

  &:not(:last-child) {
    border-bottom: 1px solid #F1F1FB;
  }
`;

export const ListItemDescription = styled('span')`
  display: inline-block;
  color: #A9A9C2;
  font-size: 14px;
  line-height: 19px;
`;

export const ListItemTextWrapper = styled(ListItemText)`
  &>span {
    font-size: 14px;
  }
`;


export const TextWrapper = styled('div')`
  line-height:  16px;

  &>div {
    margin: 0;
  }
`;